module.exports = __webpack_public_path__ + "static/media/icon-close.ddd30ca2.svg";